import React, { useState } from 'react';
import AxiosClient from '../../assets/AxiosClient';
import { useStateContext } from '../../Contexts/ContextProvider';
import { useNavigate, useParams } from 'react-router-dom';

const FileReplacementForm = () => {
const {id} = useParams () ;
  const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const { SetNotification } = useStateContext();
const navigate= useNavigate() ; 
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleFileReplace = async () => {
    if (!file) {
      setError('Please select a file to upload.');
      return;
    }

    setIsUploading(true);
    setError(null);

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await AxiosClient.post(`/public-files/${id}/replace`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      SetNotification('File replaced', 'success');
      // Handle success message or redirect after file replacement
      navigate(-1); 
    } catch (error) {
      console.error('File replacement error:', error);
      setError('Error replacing file. Please try again.');
    }

    setIsUploading(false);
  };

  return (
    <div>
      <h2>Replace File</h2>
      <input
        type="file"
        onChange={handleFileChange}
        className="py-2 m-2 px-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
      />
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {isUploading ? (
        <p>Uploading...</p>
      ) : (
        <button onClick={handleFileReplace} className="btn btn-primary">
          Replace File
        </button>
      )}
    </div>
  );
};

export default FileReplacementForm;
